class Constants {
    static APIURL = "https://intg-pltfm-test-svc-eu-dev.nodemanagement-test.nikecloud.com";
}

export { Constants };
